module.exports = __webpack_public_path__ + "static/media/pOPEN.d6622364.webp";